import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { _ } from './utils';

@Injectable()
export class DatepickerI18n extends NgbDatepickerI18n {
  constructor(private translate: TranslateService) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return this.translate.instant([
      _('Mo'),
      _('Tu'),
      _('We'),
      _('Th'),
      _('Fr'),
      _('Sa'),
      _('Su'),
    ][weekday - 1]);
  }

  getMonthShortName(month: number, year?: number): string {
    return this.translate.instant([
      _('Jan'),
      _('Feb'),
      _('Mar'),
      _('Apr'),
      _('May'),
      _('Jun'),
      _('Jul'),
      _('Aug'),
      _('Sep'),
      _('Oct'),
      _('Nov'),
      _('Dec'),
    ][month - 1]);
  }

  getMonthFullName(month: number, year?: number): string {
    return this.translate.instant([
      _('January'),
      _('February'),
      _('March'),
      _('April'),
      // TODO: fix this ugly hack to get a separate translation for the long form
      _('May '),
      _('June'),
      _('July'),
      _('August'),
      _('September'),
      _('October'),
      _('November'),
      _('December'),
    ][month - 1]).trim();
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}.${date.month}.${date.year}`;
  }
}
